import { useState, useEffect } from 'react';
import moment from 'moment';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip } from '@mui/material';
import { NoRecordFound, PageLoader } from '../../../shared_elements';
import { ShowAttachments } from '../../../shared_elements/components';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import { getApprovalFlowimelineApi } from '../apiService';
import AttachFileIcon from '@mui/icons-material/AttachFile';


const ApprovalTimeline = ({ timeLineData, toggleModalFn, approvalSlugs = [], invoiceSlug }) => {
    const headerArr = ["Status From", "Status To", "Changed By", "Created At", "Reason", "Attachments"]
    const [isLoading, setLoading] = useState({ pageLoader: false });
    const toggleLoader = (type, status) => { setLoading({ [type]: status }) }
    const [timeLine, setTimeLine] = useState([]);
    const [attachmentsModal, setAttachmentsModal] = useState({ modal: false, data: null });
    
    const getTimeLineHistory = async () => {
        if (!approvalSlugs.length) return
        toggleLoader("pageLoader", true)
        const responses = await Promise.all(
            approvalSlugs.map(slug => globalGetService(getApprovalFlowimelineApi(invoiceSlug, slug)))
        )
        toggleLoader("pageLoader", false)
        const combined = responses
            .filter(r => checkApiStatus(r))
            .flatMap(r => r?.data?.data || [])
        setTimeLine(combined)
    }

    useEffect(() => {
        getTimeLineHistory()
    }, [])

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit Status TimeLine`, page_type: page_type, })
    }

    return (
        <>
            {isLoading?.pageLoader ? <PageLoader /> :
                <Dialog
                    open={timeLineData?.modal}
                    aria-labelledby="scroll-dialog-title"
                    className='add-lease-dialog'
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="scroll-dialog-title">Approval Flow Timeline </DialogTitle>
                    <DialogContent dividers={true} sx={{ p: 2 }}>
                        <TableContainer style={{ maxHeight: !isLoading?.pageLoader && timeLine?.length === 0 ? "auto" : `${window.innerHeight - 480}px`, overflow: "auto", }} component={Paper} className="scrollable-table scrollable-table-container">
                            <Table size="small" className="mui-table-format" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {headerArr.map((header, idx) => (
                                            <TableCell key={idx} className={'nowrap-cell range-header'} sx={{ whiteSpace: 'nowrap' }}>
                                                <b>{header}</b>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {timeLine?.length > 0 && timeLine?.map((row, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell sx={{minWidth: "100px"}}> {row?.payout_status_from?.label || row?.status_from?.label || "--"} </TableCell>
                                                <TableCell sx={{minWidth: "100px"}}> {row?.payout_status_to?.label || row?.status_to?.label || "--"} </TableCell>
                                                <TableCell sx={{minWidth: "100px"}}>{row?.changed_by?.name ?? "--"}</TableCell>
                                                <TableCell sx={{minWidth: "120px",whiteSpace: 'nowrap'}}> {row?.created_at && moment(row.created_at).isValid() ? moment(row.created_at).format('MMM DD, YYYY, hh:mm A') : "--"}</TableCell>
                                                <TableCell sx={{minWidth: "100px"}}>{row?.comment ?? "--"}</TableCell>
                                                <TableCell sx={{minWidth: "100px"}}>
                                                    {row?.attachments?.length > 0 ? (
                                                        <Tooltip title="View Attachments" arrow>
                                                            <Box
                                                                sx={{ display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    handleItemClicked('AttachmentsIcon')
                                                                    setAttachmentsModal({ modal: true, data: { attachments: row.attachments } })
                                                                }}
                                                            >
                                                                <AttachFileIcon fontSize="small" color="primary" />
                                                                <Box className="attachment-count">({row.attachments.length})</Box>
                                                            </Box>
                                                        </Tooltip>
                                                    ) : '--'}
                                                </TableCell>
                                            </TableRow>)
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {!isLoading?.pageLoader && timeLine?.length === 0 && <NoRecordFound />}
                    </DialogContent>
                    <DialogActions>
                        <Box style={{ float: 'right' }}>
                            <Button className='cancel-btn' onClick={() => { toggleModalFn(); handleItemClicked('Close Button') }} color="primary" variant='outlined' sx={{ marginRight: "5px" }} size="small">Close</Button>
                        </Box>
                    </DialogActions>
                </Dialog>}
            {attachmentsModal.modal && (
                <ShowAttachments
                    moduleName="Approval Timeline"
                    attachmentsData={attachmentsModal}
                    toggleModalFn={() => setAttachmentsModal({ modal: false, data: null })}
                    permissionKey='invoices'
                    onViewDisabled={true}
                />
            )}
        </>
    )
}
export default ApprovalTimeline